import React, { useState } from "react";
import {
  pdf,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
  PDFViewer,
} from "@react-pdf/renderer";
import Html from "react-pdf-html";
import ContainerContent from "components/Container/ContainerContent";
// import font from "../../styles/Sarabun-Regular.ttf";
// import fontBold from "../../styles/Sarabun-Bold.ttf";
import ReactDOMServer from "react-dom/server";
import classNames from "classnames";
import { API, Auth } from "aws-amplify";
import { getDetailSegment } from "../../utils/buro";
import { differenceInDays } from "date-fns";

Font.register({
  family: "Sarabun",
  fonts: [
    { src: "/fonts/Sarabun-Regular.ttf" },
    { src: "/fonts/Sarabun-Bold.ttf" },
  ],
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "Sarabun",
    padding: 24,
    fontSize: 12,
    backgroundColor: "#fff",
  },
  myFont: {
    fontSize: "14px",
  },
  myFont2: {
    fontSize: "13px",
  },
  logo: { height: 90, width: 140 },
  title: {
    textAlign: "center",
  },
  box: {
    border: 1,
    borderRadius: 5,
    padding: 8,
    flex: 1,
    marginTop: 8,
  },
  flexline: {
    display: "flex",
    flexDirection: "row",
  },
  header_table: {
    marginTop: 8,
    padding: 4,
    display: "flex",
    flexDirection: "row",
  },
  table: {
    border: 1,
    borderTop: 0,
    padding: 4,
    display: "flex",
    flexDirection: "row",
  },
  columnDesc: { flex: 6, textAlign: "center" },
  columnQty: { flex: 1, textAlign: "center" },
  columnRentalPeriod: { flex: 1 },
  columnNormal: { flex: 2 },
  titleCondition: {
    marginTop: 5,
  },
  rowCondition: {
    display: "flex",
    flexDirection: "row",
  },
  pageNumber: {
    position: "absolute",
    top: 20,
    right: 20,
  },
  signatureContainer: {
    position: "absolute",
    display: "flex",
    flexDirection: "row",
    marginTop: 12,
    bottom: 20,
  },
  signatureBox: {
    width: "50%",
  },
  textCenter: { textAlign: "center" },
  footerPaddingLeft: { paddingLeft: 80 },
});

const getDateStr = (dateStr) => {
  if (!dateStr || dateStr === "19000101") return "-";
  const year = dateStr.slice(0, 4);
  const month = dateStr.slice(4, 6);
  const date = dateStr.slice(6, 8);
  return `${date}-${month}-${+year + 543}`;
};

const getOverDueDate = (overdue_date, oriLoan) => {
  if (!overdue_date || oriLoan?.loan_status === "DONE") return "-";

  const diff_days = differenceInDays(new Date(), new Date(overdue_date));
  return diff_days > 0 ? diff_days : 0;
};

export const elementReportNCB = (dataPdf, oriLoan) => {
  return (
    <html>
      <body>
        <style>
          {`
              *{
                font-family: Sarabun;
              }
              .wrapper_report{
                font-size: 14px;
               
                text-align: center;
                margin-top: 15px;
                color: #0000FF;
              }

              .wrapper_report_detail{
                margin-top: 22px;
              }

              .text-blue{
                color: #0000FF;
              }

              .border{
                border: 1px solid #000;
                padding: 5px 7px;
              }

              .clear-border-bottom {
                border-bottom: 0px solid #000;
              }

              .title{
                display: flex;
                font-size: 12px;
                width: 90px;
              }

              .desc{
                display: flex;
                flex-direction: row;
                font-size: 10px;
                margin-top: 8px;
                margin-left: 4px;
                width: 50%;
              }

              .desc-address{
                display: flex;
                flex-direction: row;
                font-size: 10px;
                margin-top: 8px;
                margin-left: 4px;
                width: 100%;
              }

              .desc-two{
                display: flex;
                justify-content: space-between;
                flex-direction: row;
              }

              .desc-right{
                display: flex;
                font-size: 10px;
                margin-left: 2px;
              }

              .desc-right-two{
                display: flex;
                margin-right: auto;
                width: 50%;
              }

              .wrapper_report_detail_footer {
                margin-top: 38px;
              }

              .wrapper_report_footer {
                margin-top: 250px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
              }
              
              .text-footer-left{
                color: #FF4500;
                text-decoration: underline;
                width: 8%;
              }

              .text-footer-right{
                color: #FF4500;
                width: 92%;
              }

              .text-footer-justify{
                text-align: justify;
              }

              .text-footer-right-margin{
                margin-top: 4px;
              }

              .text-footer{
                font-size: 10px;
              }
            }`}
        </style>
        <div className="wrapper_report border">
          หนังสือแจ้งข้อมูลเครดิตที่รายงาน บริษัท ข้อมูลเครดิตแห่งชาติ จำกัด{" "}
        </div>
        <div className="wrapper_report_detail">
          <div className="title text-blue border clear-border-bottom">
            ประเภทลูกค้า{" "}
          </div>
          <div className="title text-blue border">ข้อมูลทั่วไป </div>
          <div className="desc">
            <div>ชื่อเจ้าของข้อมูล : </div>
            <div className="desc-right text-blue">
             {dataPdf?.article || ""} {dataPdf?.firstName?.value} {dataPdf?.familyName?.value}{" "}
            </div>
          </div>
          <div className="desc-two">
            <div className="desc">
              <div>เลขที่บัตรประชาชน : </div>
              <div className="desc-right text-blue">
                {" "}
                {dataPdf?.idNumber?.value}{" "}
              </div>
            </div>
            <div className="desc desc-right-two">
              <div>วันเดือนปีเกิด : </div>
              <div className="desc-right text-blue">
                {getDateStr(dataPdf?.dateOfBirth?.value)}{" "}
              </div>
            </div>
          </div>
          <div className="desc-address">
            <div>ที่อยู่ : </div>
            <div className="desc-right text-blue">
              {oriLoan.addressCode +
                " " +
                oriLoan.addressDesc +
                " " +
                oriLoan.address}
              {/* {dataPdf?.address_1?.value}&nbsp;{dataPdf?.address_2?.value}{" "} */}
            </div>
          </div>
        </div>
        <div className="wrapper_report_detail_footer">
          <div className="title text-blue border">ข้อมูลลูกค้า </div>
          <div className="desc-two">
            <div className="desc">
              <div>บัญชีเลขที่ : </div>
              <div className="desc-right text-blue">
                {dataPdf?.accountNumber?.value}{" "}
              </div>
            </div>
            <div className="desc desc-right-two">
              <div>ลักษณะบัญชี : </div>
              <div className="desc-right text-blue">- </div>
            </div>
          </div>

          <div className="desc-two">
            <div className="desc">
              <div>ประเภทสินเชื่อ : </div>
              <div className="desc-right text-blue">
                {dataPdf?.accountType?.value === "37"
                  ? "สินเชื่อรายย่อยเพื่อการประกอบอาชีพ"
                  : "สินเชื่อส่วนบุคคลภายใต้การกำกับ" || ""}{" "}
              </div>
            </div>
            <div className="desc">
              <div>วันเปิดบัญชี : </div>
              <div className="desc-right text-blue">
                {" "}
                {getDateStr(dataPdf?.dateAccountOpened?.value)}{" "}
              </div>
            </div>
          </div>

          <div className="desc-two">
            <div className="desc">
              <div>วงเงินสินเชื่อ / บัตรเครดิต : </div>
              <div className="desc-right text-blue">
                {" "}
                {dataPdf?.loanAmount?.value}{" "}
              </div>
            </div>
            <div className="desc">
              <div>วันชำระหนี้ครั้งสุดท้าย : </div>
              <div className="desc-right text-blue">
                {" "}
                {getDateStr(dataPdf?.dateOfLastPayment?.value)}{" "}
              </div>
            </div>
          </div>

          <div className="desc-two">
            <div className="desc">
              <div>ยอดหนี้คงเหลือ / วงเงินที่ใช้ : </div>
              <div className="desc-right text-blue">
                {" "}
                {dataPdf?.amountOwed?.value}{" "}
              </div>
            </div>
            <div className="desc">
              <div>วันที่เริ่มผิดนัดชำระหนี้ : </div>
              <div className="desc-right text-blue">
                {" "}
                {getDateStr(dataPdf?.defaultDate?.value)}
              </div>
            </div>
          </div>

          <div className="desc-two">
            <div className="desc">
              <div>จำนวนเงินที่ต้องชําระต่องวด&nbsp;</div>
              <div className="desc-right text-blue">
                &nbsp;:&nbsp;{dataPdf?.installmentAmount?.value}{" "}
              </div>
            </div>
            <div className="desc">
              <div>วันที่ปรับปรุงโครงสร้างหนี้ : </div>
              <div className="desc-right text-blue">
                {" "}
                {getDateStr(dataPdf?.dateOfLastDebt?.value)}{" "}
              </div>
            </div>
          </div>

          <div className="desc-two">
            <div className="desc">
              <div>ยอดหนี้ที่เกินกำหนดชําระ&nbsp;</div>
              <div className="desc-right text-blue">
                &nbsp;:&nbsp;{dataPdf?.amountPastDue?.value}
              </div>
            </div>
            <div className="desc">
              <div>ระยะเวลากู้ : </div>
              <div className="desc-right text-blue">
                {" "}
                {Number(dataPdf?.installmentNumberOfPayment?.value) || ""}{" "}
              </div>
            </div>
          </div>

          <div className="desc-two">
            <div className="desc">
              <div>สถานะบัญชี : </div>
              <div className="desc-right text-blue">
                {dataPdf?.accountStatus?.value}{" "}
              </div>
            </div>
            <div className="desc">
              <div>จำนวนวันค้างกำหนดชําระ : </div>
              <div className="desc-right text-blue">
                {getOverDueDate(oriLoan?.overdue_date, oriLoan)}{" "}
              </div>
            </div>
          </div>

          <div className="desc-two">
            <div className="desc">
              <div>ยี่ห้อ : </div>
              <div className="desc-right text-blue">-</div>
            </div>
            <div className="desc">
              <div>รุ่น : </div>
              <div className="desc-right text-blue">- </div>
            </div>
          </div>
        </div>
        <div className="wrapper_report_footer">
          <div className="text-footer-left text-footer">หมายเหตุ </div>
          <div className="text-footer text-footer-right">
            <div className="text-footer-justify">
              จำนวนเงินที่แสดงในรายงานข้อมูลเครดิตเป็นเพียงจํานวนเงินที่เป็นไปตามหลักเกณฑ์การนําส่งข้อมูลตามพระราชบัญญัติ&nbsp;
            </div>
            <div className="text-footer-right-margin text-footer-justify">
              การประกอบธุรกิจข้อมูลเครดิต พ.ศ. 2545 และที่แก้ไขเพิ่มเติม
              และประกาศคณะกรรมการคุ้มครองข้อมูลเครดิตเท่านั้น&nbsp;
            </div>
            <div className="text-footer-right-margin text-footer-justify">
              ทั้งนี้อาจแตกต่างกับยอดหนี้คงค้างที่สถาบันการเงินมีสิทธิเรียกร้องตามสัญญา
              และหรือตามที่กฎหมายกำหนด&nbsp;
            </div>
            <div className="text-footer-right-margin text-footer-justify">
              ซึ่งควรตรวจสอบข้อมูลเพิ่มเติมจากสถาบันการเงินก่อนทุกครั้ง&nbsp;
            </div>
          </div>
        </div>
      </body>
    </html>
  );
};

export const PdfBuroLetter = ({ dataPdf, oriLoan }) => {
  const getHtmlReportNCB = () => {
    const html = ReactDOMServer.renderToStaticMarkup(
      elementReportNCB(dataPdf, oriLoan)
    );
    return html;
  };

  return (
    <Document debug>
      <Page size="A4" style={styles.page}>
        <View>
          <Html>{getHtmlReportNCB()}</Html>
        </View>
      </Page>
    </Document>
  );
};

function PdfViewerMain() {
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataPdf, setDataPdf] = useState();
  const [oriLoan, setOriLoan] = useState(null);
  const [selectDate, setSelectDate] = useState(new Date());

  const onChangeSearch = async (e) => {
    const { value } = e.target;
    setSearch(value);
  };

  const onClickSubmit = async () => {
    try {
      setLoading(true);
      const datas = await API.get(
        "MoneyHubAdmin",
        `/loan/getLoanByKbankId/${search}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      if (datas.status_type === "404") {
        setError(datas.message);
      } else {
        setOriLoan(datas.loan);
        setDataPdf(
          getDetailSegment({
            currentDate: new Date(),
            dataExport: [datas.loan],
            showLog: true,
            logType: "KEY",
          })
        );
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContainerContent>
      <div className="px-8 flex mb-8 items-center space-x-2">
        <input
          type="text"
          placeholder="Search Loan id, 400141164"
          onChange={onChangeSearch}
          className=" w-56 px-3 mt-2 py-3 placeholder-blueGray-400 text-gray-600 relative bg-white rounded text-sm  border shadow outline-none focus:outline-none focus:ring"
        />
        <button
          disabled={loading}
          onClick={onClickSubmit}
          className={classNames(
            "px-2 py-3 border text-white rounded bg-green-400"
          )}
        >
          Submit
        </button>
      </div>

      <PDFViewer width={900} height={1100}>
        <PdfBuroLetter dataPdf={dataPdf} oriLoan={oriLoan} />
      </PDFViewer>
    </ContainerContent>
  );
}

export default PdfViewerMain;
